<template>
  <div id="integrated-header">
    <!-- Top Header Section -->
    <div id="header-top">
      <div class="header-left">
        <div class="tool-name">RhoFold+</div>
        <div class="tool-subtitle">RNA 3D Structure Prediction</div>
      </div>
      
      <div class="header-right">
        <div class="org-info">
          <div class="university">The Chinese University of Hong Kong</div>
          <div class="department">Department of Computer Science and Engineering</div>
          <div class="group">AIH Lab</div>
        </div>
        <img class="logo" src="@/assets/img/cuhk_emblem.png" alt="CUHK Logo">
      </div>
    </div>
    
    <!-- Navigation Bar Section -->
    <div id="header-nav">
      <b-navbar type="dark" variant="secondary">
        <b-navbar-nav id="navi" class="mx-auto">
          <b-nav-item id="navi-home" to="/" class="nav-item-custom">
            Home
          </b-nav-item>
          
          <!-- About section temporarily disabled -->
          <!-- 
          <b-nav-item id="navi-about" to="/about" class="nav-item-custom">
            About
          </b-nav-item>
          -->
          
          <b-nav-item id="navi-git" href="https://github.com/ml4bio/RhoFold" class="nav-item-custom">
            Github
          </b-nav-item>
          
          <b-nav-item id="navi-contact" to="/contact" class="nav-item-custom">
            Contact
          </b-nav-item>

          <b-nav-item-dropdown id="navi-service" class="nav-item-custom">
            <template #button-content style="color: white !important;">
              Other tools from AIH
            </template>
            <b-dropdown-item href="#" class="dropdown-item-custom">RhoFold+</b-dropdown-item>
            <b-dropdown-item href="https://proj.cse.cuhk.edu.hk/aihlab/rnafm/" class="dropdown-item-custom">RNA Foundation Model</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopHeader',
};
</script>

<style scoped>
#integrated-header {
  width: 100%;
}

/* Header Top Section */
#header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background-color: #3b6fb6;
  color: white;
}

.header-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.tool-name {
  font-family: 'Bodoni', sans-serif;
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 5px;
  line-height: 1.2;
}

.tool-subtitle {
  font-family: 'Varela Round', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #c6daf0;
  line-height: 1.2;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.logo {
  height: 60px;
  width: auto;
}

.org-info {
  text-align: right;
  line-height: 1.3;
}

.university {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 3px;
}

.department {
  font-size: 14px;
  font-weight: 400;
  color: #c6daf0;
  margin-bottom: 8px;
}

.group {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  //padding: 4px 12px;
  //background-color: rgba(255, 255, 255, 0.1);
  //border-radius: 4px;
  //border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Navigation Section */
#header-nav {
  border-top: 3px solid #2c5aa0;
  background-color: #3b6fb6;
  border-bottom: 3px solid #2c5aa0;
  padding: 0;
}

#header-nav .navbar {
  background-color: #3b6fb6 !important;
  padding: 10px 0;
}

#navi {
  width: 100%;
  justify-content: center;
}

.nav-item-custom {
  margin: 0 15px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.nav-item-custom:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-item-custom > a {
  color: white !important;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 16px !important;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.nav-item-custom > a:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
  color: white !important;
}

/* Dropdown styling */
.dropdown-toggle {
  color: white !important;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 16px !important;
  border-radius: 4px;
  transition: all 0.3s ease;
}

/* Specific styling for dropdown button text - ensure it's always white */
#navi-service .dropdown-toggle {
  color: white !important;
}

#navi-service .dropdown-toggle:focus,
#navi-service .dropdown-toggle:active,
#navi-service .dropdown-toggle:visited {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
}

/* Force the dropdown button text to be white in all states */
#navi-service .btn-secondary {
  color: white !important;
  background-color: transparent !important;
  border: none !important;
}

#navi-service .btn-secondary:not(:disabled):not(.disabled):active,
#navi-service .btn-secondary:not(:disabled):not(.disabled).active {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.dropdown-toggle:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
  color: white !important;
}

.dropdown-menu {
  background-color: #3b6fb6;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.dropdown-item-custom {
  color: white !important;
  transition: all 0.3s ease;
}

.dropdown-item-custom:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
  color: white !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  #header-top {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }
  
  .header-right {
    flex-direction: column;
    gap: 10px;
  }
  
  .org-info {
    text-align: center;
  }
  
  .tool-name {
    font-size: 28px;
  }
  
  #navi {
    flex-direction: column;
    align-items: center;
  }
  
  .nav-item-custom {
    margin: 5px 0;
  }
}
</style>

<!-- Global styles to override Bootstrap's navbar-dark transparency -->
<style>
/* High specificity overrides for Bootstrap navbar-dark styles */
#integrated-header #header-nav .navbar-dark .navbar-nav .nav-link {
  color: white !important;
  font-size: 16px !important;
}

#integrated-header #header-nav .navbar-dark .navbar-nav .nav-link:focus,
#integrated-header #header-nav .navbar-dark .navbar-nav .nav-link:hover {
  color: white !important;
}

#integrated-header #header-nav .navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.5) !important;
}

/* Override Bootstrap dropdown button styles */
#integrated-header #header-nav .navbar-dark .navbar-nav .dropdown-toggle {
  color: white !important;
  font-size: 16px !important;
  background-color: transparent !important;
  border: none !important;
}

#integrated-header #header-nav .navbar-dark .navbar-nav .dropdown-toggle:focus,
#integrated-header #header-nav .navbar-dark .navbar-nav .dropdown-toggle:hover,
#integrated-header #header-nav .navbar-dark .navbar-nav .dropdown-toggle:active {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.15) !important;
}

/* Ensure the dropdown text specifically is white */
#integrated-header #navi-service .dropdown-toggle {
  color: white !important;
}

#integrated-header #navi-service .btn-secondary {
  color: white !important;
}
</style>
